import { FormGroup } from '@angular/forms';

export class FormStateService {
  /**
   * @description
   * Takes a form group and resets the address field, while searching for the corresponding UI field by ID and blanking out the value.
   *
   * @param fg
   *
   * FormGroup containing the following 5 address fields:
   *  - street
   *  - line1
   *  - city
   *  - state
   *  - zip
   */
  static resetAddress(fg: FormGroup, index: string = ''): void {
    if (index !== '') {
      index = '-' + index;
    }

    const state = '#state' + index;
    (<HTMLInputElement>document.querySelector(state)).value = '';

    const street = '#street' + index;
    (<HTMLInputElement>document.querySelector(street)).value = '';

    const line1 = '#line1' + index;
    (<HTMLInputElement>document.querySelector(line1)).value = '';

    const line2 = '#line2' + index;
    (<HTMLInputElement>document.querySelector(line2)).value = '';

    const zip = '#zip' + index;
    (<HTMLInputElement>document.querySelector(zip)).value = '';

    const city = '#city' + index;
    (<HTMLInputElement>document.querySelector(city)).value = '';

    fg.controls.street.reset('');
    fg.controls.line1.reset('');
    fg.controls.line2.reset('');
    fg.controls.city.reset('');
    fg.controls.state.reset('');
    fg.controls.zip.reset('');
  }

  /**
   * @description
   * PA requires single spaces to be passed back to reset values.
   *
   * This accounts for that and ensures we show empty strings on the ui
   *
   *
   * @param isNewObject
   *
   * New elements are initialized with empty strings.
   *
   * Setting this field to true skips checking for empty strings so we don't load spaces onto the UI.
   *
   *
   * @return
   * Empty strings are converted to single spaces.
   *
   * Single spaces are converted to empty strings.
   *
   * Non-empty strings that have more than just a space are left untouched.
   */
  static cleanAddressString(value: string, isNewObject: boolean = false): string {
    if (value === '' && !isNewObject) {
      value = ' ';
    } else if (value === ' ') {
      value = '';
    }

    return value;
  }
}
